import { createFileRoute } from "@tanstack/react-router";
import { pageHead, packagesJsonLdScript, packagesFaqJsonLdScript } from "@/lib/seo";

const TITLE = "Pakketten & prijzen vanaf €749 | IT Solutions";
const DESC =
  "Websites vanaf €749/jaar, of eenmalig in eigendom vanaf €9.950. EU-hosting, SSL, SEO en SLA standaard inbegrepen.";

import { PakkettenPage } from "@/pages/pakketten";

export const Route = createFileRoute("/pakketten")({
  head: () => {
    const head = pageHead({
      lang: "nl",
      pathWithoutLang: "/pakketten",
      title: TITLE,
      description: DESC,
    });
    return {
      ...head,
      scripts: [packagesJsonLdScript("nl"), packagesFaqJsonLdScript("nl")],
    };
  },
  component: PakkettenPage,
});
